<template>
  <modal-template class="modal-height"
                  size="intermedium"
                  :is-static="isStatic"
                  :close="false"
                  @close="$root.$emit('closeUserProfileOnboarding')">
    <div class="no-gutters posR">
      <div class="container-onboarding">
        <h3>{{ $t('userProfileOnboarding.tuPerfil') }}</h3>
        <b-row>
          <b-col cols="12">
            <validation-observer v-slot="{ invalid }">
              <b-form @submit.prevent="fillProfile">
                <div>
                  <label class="custom-input-user-img"
                         for="userProfileImage">
                    <input id="userProfileImage"
                           accept="image/jpeg, image/png"
                           hidden
                           type="file"
                           @change="onFileChange" />
                    <div class="container-user-img">
                      <div v-if="!previewImage"
                           class="user-upload-image" />
                      <div v-if="previewImage"
                           :style="{
                          'background-image': 'url(' + previewImage + ')'
                        }"
                           class="user-upload-image preview" />
                    </div>
                  </label>
                </div>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.first_name"
                                  :placeholder="$t('userProfileOnboarding.nombre')"
                                  :class="{ error: errors[0] }"
                                  type="text"
                                  name="first_name" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.last_name"
                                  :placeholder="$t('userProfileOnboarding.apellido')"
                                  :class="{ error: errors[0] }"
                                  type="text"
                                  name="last_name" />
                  </b-form-group>
                </validation-provider>
                <b-form-row class="mB1rem">
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:1|max:2">
                      <b-form-input v-model="day"
                                    placeholder="DD"
                                    class="tAc"
                                    :class="{ error: errors[0] || birthdayError }"
                                    type="text"
                                    name="day"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:1|max:2">
                      <b-form-input v-model="month"
                                    placeholder="MM"
                                    class="tAc"
                                    :class="{ error: errors[0] || birthdayError }"
                                    type="text"
                                    name="month"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:4|max:4">
                      <b-form-input v-model="year"
                                    placeholder="YYYY"
                                    class="tAc"
                                    :class="{ error: errors[0] || birthdayError }"
                                    type="text"
                                    name="year"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                </b-form-row>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <input ref="autocomplete"
                           :placeholder="$t('userProfileOnboarding.localizacion')"
                           :class="{ error: errors[0] }"
                           class="search-location"
                           name="location"
                           type="text" />
                  </b-form-group>
                </validation-provider>
                <b-form-group>
                  <w-switch v-model="model.gender"
                            :value-left="$t('genre.hombre')"
                            :value-right="$t('genre.mujer')" />
                </b-form-group>
                <div class="tAc">
                  <button :disabled="isDisabled || invalid"
                          :class="{
                      topaz: !invalid && !isDisabled,
                      transparent: invalid || isDisabled
                    }"
                          type="submit"
                          class="btn">
                    {{ $t('userProfileOnboarding.siguiente') }}
                  </button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </div>
    </div>
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'
import WSwitch from '@/components/wswitch/WSwitch.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    ModalTemplate,
    WSwitch,
    Loader
  },
  props: {
    isStatic: {
      type: Boolean,
      default: false
    },
    purchase: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        first_name: this.$store.state.user.detail.first_name || '',
        last_name: this.$store.state.user.detail.last_name || '',
        birthday: this.$store.state.user.detail.birthday || '',
        location: this.$store.state.user.detail.location || {},
        gender: this.$store.state.user.detail.gender === 'f',
        user_image: this.$store.state.user.detail.image_url || null
      },
      day: this.$moment(
        this.$store.state.user.detail.birthday,
        'YYYY-MM-DD'
      ).isValid()
        ? this.$moment(
            this.$store.state.user.detail.birthday,
            'YYYY-MM-DD'
          ).format('DD')
        : '',
      month: this.$moment(
        this.$store.state.user.detail.birthday,
        'YYYY-MM-DD'
      ).isValid()
        ? this.$moment(
            this.$store.state.user.detail.birthday,
            'YYYY-MM-DD'
          ).format('MM')
        : '',
      year: this.$moment(
        this.$store.state.user.detail.birthday,
        'YYYY-MM-DD'
      ).isValid()
        ? this.$moment(
            this.$store.state.user.detail.birthday,
            'YYYY-MM-DD'
          ).format('YYYY')
        : '',
      previewImage: null,
      loading: false,
      birthdayError: false
    }
  },
  computed: {
    isDisabled() {
      return (
        this.model.first_name === '' ||
        this.model.last_name === '' ||
        this.birthdayError ||
        this.$moment().diff(
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'D/M/YYYY'
          ),
          'years'
        ) < 16 ||
        this.model.location.place_id === 'undefined' ||
        this.model.gender === undefined
      )
    }
  },
  mounted() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ['(cities)'] }
    )
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace()
      if (place && place.geometry && place.geometry.location) {
        this.model.location = {
          place_id: place.id,
          longitude: place.geometry.location.lng(),
          latitude: place.geometry.location.lat(),
          name: place.name
        }
      }
    })
  },
  methods: {
    onFileChange(e) {
      let file = e.target.files[0]
      this.previewImage = URL.createObjectURL(file)
      this.model.user_image = file
    },
    fillBirthday() {
      if (this.day && this.month && this.year.length === 4) {
        if (
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ).isValid()
        ) {
          if (
            this.$moment().diff(
              this.$moment(
                this.day + '/' + this.month + '/' + this.year,
                'DD/MM/YYYY'
              ),
              'years'
            ) < 16
          ) {
            this.birthdayError = true
          } else {
            this.model.birthday = this.$moment(
              this.day + '/' + this.month + '/' + this.year,
              'DD/MM/YYYY'
            ).toDate()
            this.birthdayError = false
          }
        } else {
          this.birthdayError = true
        }
      }
    },
    async fillProfile() {
      try {
        var data = {
          first_name: this.model.first_name,
          last_name: this.model.last_name,
          gender: this.model.gender ? 'm' : 'f',
          birthday: this.$moment(this.model.birthday).format('YYYY-MM-DD'),
          location: this.model.location
        }
        this.loading = true
        await this.$store.dispatch('user/update', {
          user: this.$store.state.user.detail.id,
          data: data
        })
        if (this.model.user_image && this.model.user_image.type) {
          var fd = new FormData()
          fd.append('image', this.model.user_image)
          await this.$store.dispatch('user/updateImage', {
            user: this.$store.state.user.detail.id,
            data: fd
          })
        }
        if (!this.purchase) {
          this.$root.$emit('closeUserProfileOnboarding')
          this.$root.$emit('openUserGenresOnboarding')
        } else {
          this.$root.$emit('closeUserProfilePurchase')
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import './user-profile-onboarding.sass';
</style>
